<template>
<div>
  123123
  <cardDragger :data="cardList" style="width: 100%;"
        :colNum="1">
  <!-- 在组件中间插入template并设置 v-slot:header="slotProps"
       header为标题栏的插槽名字，在里面的内容会渲染到你每一个卡片标题栏上
       slotProps为从子组件返回的数据，及data数组里面的每一个对象数据-->
       <template v-slot:header="slotProps" style="width: 100%;">
    <!-- 自定义内容 -->
    <el-row class="panel-group" v-if="slotProps.item.positionNum==1" style="width: 100%;">
      <el-col
        class="card-panel-col"
        style="width: 100%; margin: 0"
      >
        <el-card class="box-card" style="width: 100%;">
          <div slot="header" class="clearfix" style="text-align: center; font-weight: bold;">
            <span>评分指南</span>
          </div>

          <div
            
          >
            <p>这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南</p>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="panel-group" v-if="slotProps.item.positionNum==2">
      <el-col
        class="card-panel-col"
        style="width: 100%; margin: 0"
      >
        <el-card class="box-card" style="width: 100%;">
          <div slot="header" class="clearfix" style="text-align: center; font-weight: bold;">
            <span>政策标准内容</span>
          </div>

          <div
            
          >
            <p>这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南这里是评分指南</p>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </template>
  </cardDragger>
  <div style="text-align: center;"><el-button type="primary" plain @click="comeIn">开始进入</el-button></div>

</div>
</template>

<script>
//引入VueOfficeDocx组件http://localhost:9291/file/Down?filename=0524161336-1.pptx
import {cardDragger } from 'carddragger'
//引入相关样式
    export default {
        name: "TestTwo",
        components: {
          cardDragger
    },
    data() {
        return {
          cardList: [{
                positionNum: 1,
                name: "演示卡片"+1,
                id: "card"+1,
              },{
                positionNum: 2,
                name: "演示卡片"+2,
                id: "card"+2,
              }]
        }
    },
    methods: {
        renderedHandler() {
            console.log("渲染完成")
        },
        errorHandler() {
            console.log("渲染失败")
        },
        handleRemoveClick(item, done) {
        setTimeout(() => {
          console.log('handleRemoveClick', item);
          done()
        }, 2000);
      },

      /**
       * @description 点击查看预览功能
       */
      handleClick() {
        this.$preview({
          url: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',
          fid: 'aadadads',
          download: false ,//是否展示下载按钮
        })
      },
    }
    }
</script>

<style lang="less" scoped>
 ::v-deep #card1 {
  width: 100% !important;
}
::v-deep #card2 {
  width: 100% !important;
}
::v-deep .d_cardInsideBox[data-v-3ff1d053] {
  width: 100% !important;
}
::v-deep .d_cardInsideBox[data-v-3ff1d053] {
  width: 100% !important;
}
::v-deep .d_emptyContent[data-v-3ff1d053]
{
  display: none !important;
}
</style>
